export default "__VITE_ASSET__FtQrGk5r__"